import React, { FunctionComponent, useEffect, useState } from 'react';
import { useTheme } from '@mui/material/styles';
import { useNavigate, useParams } from 'react-router-dom';
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { useAtom } from 'jotai';
import { useTranslation } from 'react-i18next';
// import useMediaQuery from '@mui/material/useMediaQuery';

// import { check_subdomain } from '../../lib/server_helper';
import { fetch_all, fetch_one } from "../../../lib/v31lib";
import { loginAtom } from '../../../lib/auth';
// import { currentPracticeAtom } from '../../../lib/practice';

import {
  AppBar,
  Checkbox,
  CircularProgress,
  Divider,
  Grid,
  MenuItem,
  Paper,
  Tab,
  Tabs,
} from '@mui/material';

import {
  Button,
  DatePicker,
  NumberInput,
  Page,
  Select,
  Switcher,
  TextInput,
  Typography
} from '../../../components/v2/styled';
import { SnackSaved } from '../../../components/v2/snacks/Saved';

import { AdhProfile } from '../../../models/AdhProfile';
import { NutritionalValue } from '../../../models/NutritionalValue';
import { AdhLink } from '../../../models/AdhLink';

const { DateTime } = require("luxon");

import HelpersLanguage from '../../../actions/helpers/language';

type Props = {}

export const AdminFoodCalculationAdhProfileEdit: FunctionComponent<Props> = ({}) => {
  const [login, setLogin] = useAtom(loginAtom);
  // const [currentPractice, setCurrentPractice] = useAtom(currentPracticeAtom);
  const theme = useTheme();
  const navigate = useNavigate();
  const {t, i18n} = useTranslation(['translations']);
  const params = useParams();
  const queryClient = useQueryClient();
  
  const [currentLanguageId, setCurrentLanguageId] = useState<number>(1);
  const [objectId, setObjectId] = useState<string | undefined>(params.id);
  const [mainObject, setMainObject] = useState<AdhProfile>({
    name: ''
  });
  const [savedOpen, setSavedOpen] = useState<boolean>(false);
  const [errors, setErrors] = useState<{[z:string]: boolean}>({});

  const {
    data: object,
    isLoading: objectLoading,
    isError: objectError,
    isSuccess: objectSuccess,
    refetch: objectRefetch,
  } = useQuery({
    queryKey: ["adh_profile", login?.id, objectId],
    queryFn: () =>
      fetch_one<AdhProfile>(
        `/${i18n.resolvedLanguage || 'nl'}/v3/objects/fetch_all`,
        {
          object: 'adh_profile',
          id: objectId,
          fields: ['id', 'name', 'age_low', 'age_high', 'gender', 'is_pregnant', 'country', 'practice', 'adh_links', 'source', 'source_date', 'import_date', 'description', 'full_name', 'full_description'],
          sub_fields: {
            country: ['id', 'name', 'iso'],
            practice: ['id', 'name'],
            adh_links: ['id', 'nutritional_value', 'nutritional_value_id', 'lower_limit', 'higher_limit', 'maximum', 'is_tracked_client', 'measure_mode'],
            nutritional_value: ['id', 'name', 'has_maximum', 'measure', 'is_percentage_energy', 'is_grams_per_kilogram'],
          },
        },
        login
      ),
    select: (d) => {
      return {
        ...d,
        source_date: !!d.source_date ? DateTime.fromISO(d.source_date).toFormat("dd/LL/y") : undefined
      };
    },
    enabled: !!login?.id && parseInt(objectId || '', 10) > 0,
  });

  const {
    data: nutritionalValues,
    // isLoading: objectsLoading,
    // isError: objectsError,
    // isSuccess: objectsSuccess,
    refetch: nutritionalValuesRefetch,
  } = useQuery({
    queryKey: ["admin", "all_nutritional_values"],
    queryFn: () =>
      fetch_all<NutritionalValue>(
        `/${i18n.resolvedLanguage || 'nl'}/v3/objects/fetch_all`,
        {
          object: 'nutritional_value',
          fields: ['id', 'name', 'has_maximum', 'measure', 'is_percentage_energy', 'is_grams_per_kilogram', 'is_client_trackable_default'],
          order: "name ASC",
          per_page: 1000,
          page: 0,
          filter: {
            search: '',
            advanced: {
              is_admin: 1
            }
          }
        },
        login
      ),
    enabled: !!login?.id
  });







  const mutationSave = useMutation({
    mutationFn: (pars: {
      formData: any;
      keepOpen?: boolean
    }) => {
      return fetch_one<AdhProfile>(
        `/${i18n.resolvedLanguage || 'nl'}/v3/objects/save`,
        pars.formData,
        login
      );
    },
    onMutate: (pars: {
      formData: any;
    }) => {
      return true;
    },
    onError: (data, variables, context) => {
      return true;
    },
    onSuccess: (data, variables, context) => {
      setSavedOpen(true);
      queryClient.invalidateQueries({ queryKey: ["admin", "adh_profiles"] });
      // if (!!isReturn) {
        navigate(`/adh_profiles`);
      // } else {
      //   if (!variables.keepOpen) navigate("/knowledge_courses");
      //   if (!!variables.keepOpen && objectId === 'new') navigate(`/knowledge_course/${data.id}`);
      //   if (!!variables.keepOpen && objectId !== 'new') objectRefetch();
      // }
    },
  });









  useEffect(() => {
    if (objectId !== 'new') objectRefetch();
  }, [objectId]);
  useEffect(() => {
    setObjectId(params.id);
  }, [params.id]);
  useEffect(() => {
    if (!!objectSuccess) setMainObject(object);
  }, [object]);
  useEffect(() => {
    let err:any = {};
    if (Object.values(mainObject.full_name || []).filter(fff => !!fff).length < 1) err.name = true;
    // if (!mainObject.content_layout_key) err.content_layout_key = true;
    // if (!mainObject.author) err.author = true;
    // if (!mainObject.teaser) err.teaser = true;
    // if (!!mainObject.enabled && !mainObject.published_at) err.published_at = true;
    // if (!mainObject.coach_id) err.coach_id = true;
    // if (!mainObject.start_time) err.start_time = true;
    // if (!mainObject.end_time) err.end_time = true;
    // if (!!mainObject.start_time && !!mainObject.end_time && DateTime.fromFormat(mainObject.start_time, "dd/LL/y t") > DateTime.fromFormat(mainObject.end_time, "dd/LL/y t")) err.start_time = true;
    // if ((mainObject.max_subscribers || 0) < 1) err.max_subscribers = true;
    
    setErrors(err);
  }, [mainObject]);

  return <Page
    title={t("admin.menu.adh_profile")}
    titleCrumbs={[
      {
        title: t("admin.menu.adh_profiles"),
        path: "/adh_profiles"
      }
    ]}
  >
   <Paper sx={{padding: 2}}>
      <Grid container spacing={1}>
        <Grid item xs={12}>
          <Typography variant="h5">{t("adh_profiles.headings.general")}</Typography>
          <Divider />
        </Grid>
        <Grid item xs={12} sx={{borderLeft: "4px solid rgba(0, 0, 0, 0.54)"}}>
          <AppBar position="static" sx={{backgroundColor: theme.palette.primary.contrastText}}>
            <Tabs value={currentLanguageId} onChange={(ev, i) => {
              setCurrentLanguageId(i);
              // setFlickerEditor(true);
              // setTimeout(() => {setFlickerEditor(false);}, 200);
            }}>
              {HelpersLanguage.available_locales().map((locale, i) => {
                return (<Tab value={HelpersLanguage.mapping_to_id(locale)} label={locale.toUpperCase()} id={`locale_tab_${locale}`} />)
              })}
            </Tabs>
          </AppBar>
        </Grid>
        <Grid item xs={12} sx={{borderLeft: "4px solid rgba(0, 0, 0, 0.54)", marginTop: 1}}>
          <TextInput
            id="name"
            caption={t("admin.models.adh_profiles.name")}
            starred
            value={(mainObject?.full_name || {})[currentLanguageId] || ""}
            onChange={(e) => {
              setMainObject({
                ...mainObject,
                full_name: {
                  ...(mainObject.full_name || {}),
                  [currentLanguageId]: e
                }
              });
            }}
          />
        </Grid>
        <Grid item xs={12} sx={{borderLeft: "4px solid rgba(0, 0, 0, 0.54)", marginTop: 1}}>
          <TextInput
            id="description"
            caption={t("admin.models.adh_profiles.description")}
            value={(mainObject?.full_description || {})[currentLanguageId] || ""}
            multiline
            onChange={(e) => {
              setMainObject({
                ...mainObject,
                full_description: {
                  ...(mainObject.full_description || {}),
                  [currentLanguageId]: e
                }
              });
            }}
          />
        </Grid>
        <Grid item xs={8}>
          <TextInput
            id="source"
            caption={t("admin.models.adh_profiles.source")}
            starred
            value={mainObject.source || ''}
            onChange={(e) => {
              setMainObject({
                ...mainObject,
                source: e
              });
            }}
          />
        </Grid>
        <Grid item xs={4}>
          <Typography sx={{
            fontSize: '14px'
          }}>{t("admin.models.adh_profiles.source_date")}</Typography>
          <DatePicker
            // placeholder="DD/MM/YY"
            // autoOk={true}
            disableFuture={false}
            openTo="year"
            label=""
            format={"dd/LL/y"}
            views={["year", "month", "day"]}
            setValue={(e) => {
              setMainObject({
                ...mainObject,
                source_date: e
              });
            }}
            value={mainObject?.source_date || DateTime.now().toFormat("dd/LL/y")}
            id="source_date"
            sx={{
              box: {
                width: 'auto',
                display: 'inline-block'
              },
              field_box: {
                "svg": {
                  display: 'none'
                }
              },
              field: {
                width: 'auto',
                marginTop: 0,
                "input": {
                  textAlign: 'center'
                }
              }
            }}
          />
        </Grid>
        <Grid item xs={12} sx={{marginTop: 5}}>
          <Typography variant="h5">{t("adh_profiles.headings.profile_details")}</Typography>
          <Divider />
        </Grid>
        <Grid item xs={6}>
          <TextInput
            id="age_low"
            caption={t("admin.models.adh_profiles.age_low")}
            value={mainObject.age_low?.toString() || ''}
            onChange={(e) => {
              setMainObject({
                ...mainObject,
                age_low: !!e ? parseInt(e, 10) : undefined
              });
            }}
          />
        </Grid>
        <Grid item xs={6}>
          <TextInput
            id="age_high"
            caption={t("admin.models.adh_profiles.age_high")}
            value={mainObject.age_high?.toString() || ''}
            onChange={(e) => {
              setMainObject({
                ...mainObject,
                age_high: !!e ? parseInt(e, 10) : undefined
              });
            }}
          />
        </Grid>
        <Grid item xs={6}>
          <Select
            fullWidth
            displayEmpty
            caption={t("client.models.users.gender", "Geslacht")}
            id="gender"
            value={mainObject.gender?.toString() || ''}
            setValue={(v) => {
              setMainObject({
                ...mainObject,
                gender: parseInt(v.toString(), 10)
              });
            }}
          >
            <MenuItem value="">------</MenuItem>
            <MenuItem value={"0"}>{t("general.genders.female")}</MenuItem>
            <MenuItem value={"1"}>{t("general.genders.male")}</MenuItem>
          </Select>
        </Grid>
        <Grid item xs={4}>
          <Typography sx={{
            fontSize: '14px'
          }}>Land</Typography>
          <Typography>{mainObject?.country?.name || "-"}</Typography>
        </Grid>
        <Grid item xs={4}>
          <Switcher
            id="is_pregnant"
            caption={t("admin.models.adh_profiles.is_pregnant")}
            value={!!mainObject.is_pregnant}
            onChange={(c) => {
              setMainObject({
                ...mainObject,
                is_pregnant: !!c
              });
            }}
          />
        </Grid>
        <Grid item xs={12} sx={{marginTop: 5}}>
          <Typography variant="h5">{t("adh_profiles.headings.tracked_values")}</Typography>
          <Divider />
        </Grid>
        <Grid item xs={1}>
          <Typography sx={{textDecoration: 'underline'}}>{t("adh_profiles.values.enabled")}</Typography>
        </Grid>
        <Grid item xs={1}>
          <Typography sx={{textDecoration: 'underline'}}>{t("adh_profiles.values.tracked_for_client")}</Typography>
        </Grid>
        <Grid item xs={1}>
          <Typography sx={{textDecoration: 'underline'}}>{t("adh_profiles.values.measure_mode")}</Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography sx={{textDecoration: 'underline'}}>{t("adh_profiles.values.name")}</Typography>
        </Grid>
        <Grid item xs={1}>
          <Typography sx={{textDecoration: 'underline'}}>{t("adh_profiles.values.lower_limit")}</Typography>
        </Grid>
        <Grid item xs={1}>
          <Typography sx={{textDecoration: 'underline'}}>{t("adh_profiles.values.higher_limit")}</Typography>
        </Grid>
        <Grid item xs={1}>
          <Typography sx={{textDecoration: 'underline'}}>{t("adh_profiles.values.maximum")}</Typography>
        </Grid>
        {(nutritionalValues || []).map(nutritionalValue => <>
          <Grid item xs={1}>
            <Checkbox checked={((mainObject.adh_links || []).filter(fff => fff.nutritional_value_id === nutritionalValue?.id) || []).length > 0} onChange={(e) => {
              if (!e.target.checked) {
                let newAdhLinks:AdhLink[] = [...(mainObject.adh_links || []).filter(fff => fff.nutritional_value_id !== nutritionalValue?.id)];

                setMainObject({
                  ...mainObject,
                  adh_links: newAdhLinks
                });
              }
              if (!!e.target.checked) {
                let newAdhLinks:AdhLink[] = [...(mainObject.adh_links || []).filter(fff => fff.nutritional_value_id !== nutritionalValue?.id)];

                newAdhLinks.push({
                  nutritional_value_id: nutritionalValue?.id,
                  adh_profile_id: mainObject?.id,
                  is_tracked_client: !!nutritionalValue?.is_client_trackable_default,
                  lower_limit: undefined,
                  higher_limit: undefined,
                  maximum: undefined
                });

                setMainObject({
                  ...mainObject,
                  adh_links: newAdhLinks
                });
              }
            }} />
          </Grid>
          <Grid item xs={1}>
            <Checkbox checked={!!((((mainObject.adh_links || []).filter(fff => fff.nutritional_value_id === nutritionalValue?.id) || [])[0]) || {is_tracked_client: nutritionalValue?.is_client_trackable_default})?.is_tracked_client} onChange={(e) => {
              let newAdhLinks:AdhLink[] = [...(mainObject.adh_links || [])];
              let passed = false;

              newAdhLinks.forEach(newAdhLink => {
                if (newAdhLink.nutritional_value_id === nutritionalValue?.id) {
                  passed = true;
                  newAdhLink.is_tracked_client = !!e.target.checked;
                }
              });
              if (!passed) {
                newAdhLinks.push({
                  nutritional_value_id: nutritionalValue?.id,
                  adh_profile_id: mainObject?.id,
                  is_tracked_client: !!e.target.checked
                });
              }

              setMainObject({
                ...mainObject,
                adh_links: newAdhLinks
              });
            }} />
          </Grid>
          <Grid item xs={1} sx={{paddingTop: '14px !important'}}>
            {((mainObject.adh_links || []).filter(fff => fff.nutritional_value_id === nutritionalValue?.id) || []).length > 0 && <Select
              id={["nutri_val_mm", nutritionalValue.id].join("_")}
              value={(((mainObject.adh_links || []).filter(fff => fff.nutritional_value_id === nutritionalValue?.id) || [])[0] || {})?.measure_mode?.toString() || '0'}
              setValue={(e) => {
                let newAdhLinks:AdhLink[] = [...(mainObject.adh_links || [])];
                let passed = false;
                let meas_mode = (!e || e.toString() === '') ? 0 : parseInt(e.toString(), 10);

                newAdhLinks.forEach(newAdhLink => {
                  if (newAdhLink.nutritional_value_id === nutritionalValue?.id) {
                    passed = true;
                    newAdhLink.measure_mode = meas_mode;
                  }
                });
                if (!passed) {
                  newAdhLinks.push({
                    nutritional_value_id: nutritionalValue?.id,
                    adh_profile_id: mainObject?.id,
                    measure_mode: meas_mode
                  });
                }

                setMainObject({
                  ...mainObject,
                  adh_links: newAdhLinks
                });
              }}
              sx={{marginTop: 0, height: '30px'}}
            >
              {!!nutritionalValue.measure && <MenuItem value="0">{nutritionalValue.measure}</MenuItem>}
              {!!nutritionalValue.is_grams_per_kilogram && <MenuItem value="1">g/kg</MenuItem>}
              {!!nutritionalValue.is_percentage_energy && <MenuItem value="2">% EN</MenuItem>}
            </Select>}
          </Grid>
          <Grid item xs={6}>
            <Typography sx={{lineHeight: '42px'}}>{nutritionalValue.name}{!!nutritionalValue.measure || !!nutritionalValue.is_grams_per_kilogram ? " (" : " "}{!!nutritionalValue.measure ? `${nutritionalValue.measure}` : ''}{!!nutritionalValue.is_grams_per_kilogram ? `/kg` : ''}{!!nutritionalValue.measure || !!nutritionalValue.is_grams_per_kilogram ? ")" : ""}{!!nutritionalValue.is_percentage_energy ? `(% EN)` : ''}</Typography>
          </Grid>
          <Grid item xs={1}>
            {((mainObject.adh_links || []).filter(fff => fff.nutritional_value_id === nutritionalValue?.id) || []).length > 0 && <NumberInput
              id={["nutri_val_low", nutritionalValue.id].join("_")}
              value={(((mainObject.adh_links || []).filter(fff => fff.nutritional_value_id === nutritionalValue?.id) || [])[0] || {})?.lower_limit}
              onChange={(n: number | undefined) => {
                let newAdhLinks:AdhLink[] = [...(mainObject.adh_links || [])];
                let passed = false;

                newAdhLinks.forEach(newAdhLink => {
                  if (newAdhLink.nutritional_value_id === nutritionalValue?.id) {
                    passed = true;
                    newAdhLink.lower_limit = n;
                  }
                });
                if (!passed) {
                  newAdhLinks.push({
                    nutritional_value_id: nutritionalValue?.id,
                    adh_profile_id: mainObject?.id,
                    lower_limit: n
                  });
                }

                setMainObject({
                  ...mainObject,
                  adh_links: newAdhLinks
                });
              }}
              sx={{marginTop: 0, height: '30px'}}
            />}
          </Grid>
          <Grid item xs={1}>
            {((mainObject.adh_links || []).filter(fff => fff.nutritional_value_id === nutritionalValue?.id) || []).length > 0 && <NumberInput
              id={["nutri_val_high", nutritionalValue.id].join("_")}
              value={(((mainObject.adh_links || []).filter(fff => fff.nutritional_value_id === nutritionalValue?.id) || [])[0] || {})?.higher_limit}
              onChange={(n: number | undefined) => {
                let newAdhLinks:AdhLink[] = [...(mainObject.adh_links || [])];
                let passed = false;

                newAdhLinks.forEach(newAdhLink => {
                  if (newAdhLink.nutritional_value_id === nutritionalValue?.id) {
                    passed = true;
                    newAdhLink.higher_limit = n;
                  }
                });
                if (!passed) {
                  newAdhLinks.push({
                    nutritional_value_id: nutritionalValue?.id,
                    adh_profile_id: mainObject?.id,
                    higher_limit: n
                  });
                }

                setMainObject({
                  ...mainObject,
                  adh_links: newAdhLinks
                });
              }}
              sx={{marginTop: 0, height: '30px'}}
            />}
          </Grid>
          <Grid item xs={1}>
            {((mainObject.adh_links || []).filter(fff => fff.nutritional_value_id === nutritionalValue?.id) || []).length > 0 && !!nutritionalValue?.has_maximum && <NumberInput
              id={["nutri_val_max", nutritionalValue.id].join("_")}
              value={(((mainObject.adh_links || []).filter(fff => fff.nutritional_value_id === nutritionalValue?.id) || [])[0] || {})?.maximum}
              onChange={(n: number | undefined) => {
                let newAdhLinks:AdhLink[] = [...(mainObject.adh_links || [])];
                let passed = false;

                newAdhLinks.forEach(newAdhLink => {
                  if (newAdhLink.nutritional_value_id === nutritionalValue?.id) {
                    passed = true;
                    newAdhLink.maximum = n;
                  }
                });
                if (!passed) {
                  newAdhLinks.push({
                    nutritional_value_id: nutritionalValue?.id,
                    adh_profile_id: mainObject?.id,
                    maximum: n
                  });
                }

                setMainObject({
                  ...mainObject,
                  adh_links: newAdhLinks
                });
              }}
              sx={{marginTop: 0, height: '30px'}}
            />}
          </Grid>
        </>)}












        <Grid item xs={12} sx={{
          alignContent: 'baseline',
          textAlign: 'center',
          position: {
              xs: 'relative',
              md: 'sticky'
            },
          bottom: '-24px',
          backgroundColor: 'white',
          zIndex: 1201
        }}>
          <Divider sx={{marginTop: 1, marginBottom: 0}} />

          {!!mutationSave.isPending && <CircularProgress />}
          {!mutationSave.isPending && <Button
            label={t("shared.buttons.save")}
            id='save'
            disabled={Object.keys(errors).length > 0}
            contained
            onClick={(v) => {
              let trans:{[s:string]: {[n:number]: string}} = {};
              // @ts-ignore
              mainObject.name = ((mainObject.full_name || {})[1] || '')
              trans['name'] = {};
              // @ts-ignore
              Object.keys(mainObject.full_name || {}).filter(fff => fff.toString() !== '1').forEach(mm => {
              // @ts-ignore
                trans['name'][parseInt(mm, 10)] = (mainObject.full_name || {})[parseInt(mm, 10)];
              });
              // @ts-ignore
              mainObject.description = ((mainObject.full_description || {})[1] || '')
              trans['description'] = {};
              // @ts-ignore
              Object.keys(mainObject.full_description || {}).filter(fff => fff.toString() !== '1').forEach(mm => {
              // @ts-ignore
                trans['description'][parseInt(mm, 10)] = (mainObject.full_description || {})[parseInt(mm, 10)];
              });

              mutationSave.mutate({
                formData: {
                  object: 'adh_profile',
                  handler_id: login?.id,
                  fields: ['id'],
                  ob: {
                    ...mainObject,
                    id: parseInt(objectId || '', 10) > 0 ? objectId : undefined,
                    country: undefined,
                    country_id: mainObject?.country?.id
                  },
                  translations: trans
                },
              });
            }}
            sx={{marginBottom: 1, marginTop: 1}}
          />}
          {/* {!mutationSave.isPending && <Button
            label={t("shared.buttons.save_keep_open")}
            id='save_opened'
            disabled={Object.keys(errors).length > 0}
            contained
            onClick={(v) => {
              saveObject(true);
            }}
            sx={{marginLeft: 1, marginBottom: 1, marginTop: 1}}
          />} */}
          {!mutationSave.isPending && <Button
            label={t("shared.buttons.cancel")}
            id='cancel'
            text
            // contained
            onClick={(v) => {
              navigate("/adh_profiles");
            }}
            sx={{marginLeft: 1, marginBottom: 1, marginTop: 1}}
          />}
        </Grid>
      </Grid>
    </Paper>
    
    <SnackSaved open={savedOpen} setOpen={setSavedOpen} />
  </Page>;
}
